import { ApolloError, gql, useQuery } from '@apollo/client';

import { MaDealType } from '@/types/GraphqlSchema';

const MA_DEAL_TYPES_QUERY = gql`
  {
    maDealTypes {
      id
      name
      group
    }
  }
`;

type UseGetDealTypesResult = {
  dealTypes: MaDealType[];
  loading: boolean;
  error: ApolloError | undefined;
};

export const useGetDealTypes: () => UseGetDealTypesResult = () => {
  const { data, loading, error } = useQuery(MA_DEAL_TYPES_QUERY);

  return {
    dealTypes: data?.maDealTypes || [],
    loading,
    error,
  };
};
